// extracted by mini-css-extract-plugin
export default {"wrapper":"AccessibilityElement__wrapper--19Y","inline":"AccessibilityElement__inline--2P7","focused":"AccessibilityElement__focused--2Cb"};